import React from "react"
import StaticSelector from "components/Atoms/StaticSelector"
import useExternalGroups from "hooks/useExternalGroups"

const SupplierSelect = ({ onChange, value }) => {
  const list = useExternalGroups()

  return (
    <StaticSelector
      formGroupProps={{
        className: "mb-0 mr-2",
      }}
      items={list ?? []}
      renderText={() => value}
      onChange={onChange}
    />
  )
}

export default SupplierSelect
